import Vue from 'vue'

Vue.component('TargetTop', () => import('./TargetTop.vue'))
Vue.component('CurrentTarget', () => import('./CurrentTarget.vue'))
Vue.component('PendingList', () => import('./PendingList.vue'))
Vue.component('InAttendenceList', () => import('./InAttendenceList.vue'))
Vue.component('NextTargets', () => import('./NextTargets.vue'))